import React, { Component } from 'react';
import { Grid,Cell} from 'react-md';
//Local Import
import LoadingSpinner from '../components/LoadingSpinner'
import ScoreWheel from '../ui/takeQuiz/ScoreWheel'



//CSS Import

export default class Quizes extends Component {
 constructor(props)
 {
   super(props);

   this.state = {
     loading:false,
     isError:false
   }

 }


 

 


  render() {
    //Show Loading When Contents are Being Loaded
    if(this.state.loading)
      return <LoadingSpinner></LoadingSpinner>;

    return (
        <Cell size={12}>
            <Grid gutter={3} className=" noMarigin DisplayTableGrid noHorizondalPadding noTopPadding">
                  
                <Cell size={12} className="noMarigin fullWidth">                  
                  <ScoreWheel score={90}  
                  title="Category2" 
                  colorOne="blue"
                  colorTwo="green"
                  colorThree="darkgreen"
                  ></ScoreWheel>                     
                </Cell>
            </Grid>
        </Cell>
    );
  }
}
